
import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [

      // DASHBOARD
        {
          path: '/',
          name: 'project',
          component: () => import('./views/dashboard/Project.vue'),
          meta: { 
            auth: true 
          }
        },
        {
          path: '/finance',
          name: 'finance',
          component: () => import('./views/dashboard/Finance.vue'),
          meta: { 
            auth: true 
          }
        },

      // USER
        {
          path: '/user/setting',
          name: 'user-setting',
          component: () => import('@/views/user/setting/UserSetting.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User Setting', active: true }
            ],
            pageTitle: 'Setting',
            auth: true
          }
        },

        {
          path: '/users',
          name: 'users',
          component: () => import('@/views/user/UsersList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Users', active: true }
            ],
            pageTitle: 'Users',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

      // CONFIG
        {
          path: '/config/menu',
          name: 'menu',
          component: () => import('@/views/config/menu/MenuList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Menu', active: true }
            ],
            pageTitle: 'Menu',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/config/nav_menu',
          name: 'nav_menu',
          component: () => import('@/views/config/menu/NavMenuList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Navigation Menu', active: true }
            ],
            pageTitle: 'Navigation Menu',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
  
        {
          path: '/config/roles',
          name: 'roles',
          component: () => import('@/views/config/role/RoleList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Roles', active: true }
            ],
            pageTitle: 'Roles',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/config/role/menu/:slug',
          name: 'role-menu',
          component: () => import('@/views/config/role/RoleMenuList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Role Menu', active: true }
            ],
            pageTitle: 'Role Menu',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
      
        {
          path: '/config/options',
          name: 'options',
          component: () => import('@/views/config/options/OptionsList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Options', active: true }
            ],
            pageTitle: 'Options',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/config/category',
          name: 'category',
          component: () => import('@/views/config/category/CategoryList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Category', active: true }
            ],
            pageTitle: 'Category',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

      // TERMS
        {
          path: '/accounting/kontak',
          name: 'kontak',
          component: () => import('@/views/accounting/kontak/KontakList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Kontak', active: true }
            ],
            pageTitle: 'Kontak',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
      
      // ACCOUNTING

        {
          path: '/accounting/akun',
          name: 'akun',
          component: () => import('@/views/accounting/akun/AkunList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Akun', active: true }
            ],
            pageTitle: 'Akun',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/accounting/jurnal/:filter',
          name: 'jurnal',
          component: () => import('@/views/accounting/jurnal/Jurnal.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Jurnal', active: true }
            ],
            pageTitle: 'Jurnal',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/accounting/buku-besar/:filter',
          name: 'buku-besar',
          component: () => import('@/views/accounting/buku-besar/BukuBesar.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Buku Besar', active: true }
            ],
            pageTitle: 'Buku Besar',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/accounting/neraca',
          name: 'neraca',
          component: () => import('@/views/accounting/neraca/Neraca.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Neraca', active: true }
            ],
            pageTitle: 'Neraca',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
      //

        {
          path: '/proyek/bahan-bangunan',
          name: 'bahan-bangunan',
          component: () => import('@/views/proyek/bahan-bangunan/BahanBangunanList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Bahan Bangunan', active: true }
            ],
            pageTitle: 'Bahan Bangunan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/alat',
          name: 'alat',
          component: () => import('@/views/proyek/alat/AlatList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Alat', active: true }
            ],
            pageTitle: 'Alat',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/tenaga',
          name: 'tenaga',
          component: () => import('@/views/proyek/tenaga/TenagaList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Tenaga', active: true }
            ],
            pageTitle: 'Tenaga',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },
        
        {
          path: '/proyek/bidang',
          name: 'bidang',
          component: () => import('@/views/proyek/pekerjaan-bidang/BidangList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Bidang Pekerjaan', active: true }
            ],
            pageTitle: 'List Bidang Pekerjaan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/divisi',
          name: 'divisi',
          component: () => import('@/views/proyek/pekerjaan-divisi/DivisiList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Divisi Pekerjaan', active: true }
            ],
            pageTitle: 'List Divisi Pekerjaan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/kelompok',
          name: 'kelompok',
          component: () => import('@/views/proyek/pekerjaan-kelompok/KelompokList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Kelompok Pekerjaan', active: true }
            ],
            pageTitle: 'List Kelompok Pekerjaan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/subpekerjaan',
          name: 'subpekerjaan',
          component: () => import('@/views/proyek/pekerjaan-sub/SubList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Sub Pekerjaan', active: true }
            ],
            pageTitle: 'List Sub Pekerjaan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

      // MENU 

        {
          path: '/config/item_menu/:slug_nav_menu',
          name: 'item_menu',
          component: () => import('@/views/config/menu/ItemMenuList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Navigation Menu', url: '/config/nav_menu' },
              { title: 'Item Menu', active: true }
            ],
            pageTitle: 'Item Menu',
            parent: 'item_menu',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

      // PROYEK

        {
          path: '/proyek/unit',
          name: 'unit',
          component: () => import('@/views/proyek/unit/UnitList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Unit', active: true }
            ],
            pageTitle: 'Unit',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/analisa',
          name: 'analisa',
          component: () => import('@/views/proyek/analisa/AnalisaList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Analisa Harga Satuan Pekerjaan', active: true }
            ],
            pageTitle: 'A H S P',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/anggaran',
          name: 'anggaran',
          component: () => import('@/views/proyek/anggaran/AnggaranList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rencana Anggaran Biaya', active: true }
            ],
            pageTitle: 'R A B',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/pekerjaan/:id/:filter',
          name: 'pekerjaan',
          component: () => import('@/views/proyek/anggaran/pekerjaan/Pekerjaan.vue'),
          meta: {
            pageTitle: 'R A B',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/jadwal/:id',
          name: 'jadwal',
          component: () => import('@/views/proyek/anggaran/jadwal/Jadwal.vue'),
          meta: {
            pageTitle: 'Time Schedule',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/kebutuhan/tenaga/:id',
          name: 'kebutuhan-tenaga',
          component: () => import('@/views/proyek/anggaran/kebutuhan/KebutuhanTenaga.vue'),
          meta: {
            pageTitle: 'Kebutuhan Tenaga',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/kebutuhan/bahan/:id',
          name: 'kebutuhan-bahan',
          component: () => import('@/views/proyek/anggaran/kebutuhan/KebutuhanBahan.vue'),
          meta: {
            pageTitle: 'Kebutuhan Bahan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/kebutuhan/alat/:id',
          name: 'kebutuhan-alat',
          component: () => import('@/views/proyek/anggaran/kebutuhan/KebutuhanAlat.vue'),
          meta: {
            pageTitle: 'Kebutuhan Alat',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/rekap/:pekerjaan/:id',
          name: 'rekap-pekerjaan',
          component: () => import('@/views/proyek/anggaran/pekerjaan/Rekap.vue'),
          meta: {
            pageTitle: 'Rekap Pekerjaan',
            auth: true,
            role: ['2','7'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/pelaksanaan',
          name: 'pelaksanaan',
          component: () => import('@/views/proyek/pelaksanaan/PelaksanaanList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Pelaksanaan Proyek', active: true }
            ],
            //pageTitle: 'Pelaksanaan',
            auth: true,
            role: ['2','5'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/pelaksanaan/progress/:id/:filter',
          name: 'progress',
          component: () => import('@/views/proyek/pelaksanaan/progress/Progress.vue'),
          meta: {
            pageTitle: 'Progress',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/pelaksanaan/biaya/:id',
          name: 'biaya-pelaksanaan',
          component: () => import('@/views/proyek/pelaksanaan/progress/ProgressBiaya.vue'),
          meta: {
            pageTitle: 'Biaya Pelaksanaan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/proyek/pelaksanaan/kalender/:id',
          name: 'kalender-pelaksanaan',
          component: () => import('@/views/proyek/pelaksanaan/progress/ProgressCalendar.vue'),
          meta: {
            pageTitle: 'Kalender Pelaksanaan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

      // TRANKSAKSI
        /* Master
        {
          path: '/tranksaksi/:sub_type/:filter_type/:filter',
          name: 'tranksaksi',
          component: () => import('@/views/tranksaksi/kas/Kas.vue'),
          meta: {
            //pageTitle: 'Cash & Bank',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        }
        */

        {
          path: '/tranksaksi/kas-bank/:filter_type/:filter',
          name: 'kas-bank',
          component: () => import('@/views/tranksaksi/kas/Kas.vue'),
          meta: {
            pageTitle: 'Cash & Bank',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/tranksaksi/pembelian/:filter_type/:filter',
          name: 'pembelian',
          component: () => import('@/views/tranksaksi/pembelian/Pembelian.vue'),
          meta: {
            pageTitle: 'Pembelian',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/tranksaksi/sewa/:filter_type/:filter',
          name: 'sewa',
          component: () => import('@/views/tranksaksi/sewa/Sewa.vue'),
          meta: {
            pageTitle: 'Sewa',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/tranksaksi/biaya/:filter_type/:filter',
          name: 'biaya',
          component: () => import('@/views/tranksaksi/biaya/Biaya.vue'),
          meta: {
            pageTitle: 'Biaya',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/tranksaksi/produksi/:filter_type/:filter',
          name: 'produksi',
          component: () => import('@/views/tranksaksi/produksi/Produksi.vue'),
          meta: {
            pageTitle: 'Produksi Biaya',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
        /*
        {
          path: '/tranksaksi/penjualan/:filter_type/:filter',
          name: 'penjualan',
          component: () => import('@/views/tranksaksi/penjualan/Penjualan.vue'),
          meta: {
            pageTitle: 'Penjualan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
        */

      // ASET
        {
          path: '/aset/:taxonomy/:filter',
          name: 'Aset',
          component: () => import('@/views/accounting/aset/Aset.vue'),
          meta: {
            pageTitle: 'Aset',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
        

      // STOK

        {
          path: '/stok/produk/:filter/:status',
          name: 'stok-produk',
          component: () => import('@/views/proyek/pelaksanaan/PelaksanaanList.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Stok Produk', active: true }
            ],
            //pageTitle: 'Pelaksanaan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },

        {
          path: '/stok/material',
          name: 'stok-material',
          component: () => import('@/views/accounting/stok/material/Material.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Material', active: true }
            ],
            //pageTitle: 'Pelaksanaan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
        
        {
          path: '/stok/material/penyimpanan/:slug',
          name: 'stok-material-penyimpanan',
          component: () => import('@/views/accounting/stok/material/Penyimpanan.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Penyimpanan', active: true }
            ],
            //pageTitle: 'Pelaksanaan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        },
        
        {
          path: '/stok/material/penyimpanan/histori/:slug',
          name: 'stok-material-penyimpanan-histori',
          component: () => import('@/views/accounting/stok/material/Histori.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Histori Penyimpanan', active: true }
            ],
            //pageTitle: 'Pelaksanaan',
            auth: true,
            role: ['2'],
            //level: ['1'],
          }
        }
        

      ],
    },

    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            auth: true,
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },

    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if(store.getters['auth/guest']){
      next({ name: 'login' })
    }
    else{
      next()
    } 
  } else {
    next()
  }

  if (to.matched.some(record => record.meta.role)) {
    //if (store.getters['auth/otoritas'] === to.meta.role) {
    if (to.meta.role.includes(store.getters['auth/otoritas']) === true) {
      next()
    } else {
      next({ name: 'page-not-authorized' })
    }
  } else {
    next()
  }

/*
  if (to.matched.some(record => record.meta.level)) {
    //let level_user = ;
    if (to.meta.level.includes(store.getters['auth/level']) === true) {
      next()
    } else {
      next({ name: 'page-not-authorized' })
    }
  } else {
    next()
  }
*/

})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
